<mat-toolbar class="header-create"
  [class.header-create--with-stepper]="isWizardRoute"
  [class.header-create--field-step]="isFieldStep()"
  [class.header-create--with-menu]="showSidebarToggle">
  @if (showSidebarToggle) {
    <button mat-icon-button type="button" class="header-create-menu-btn" (click)="onToggleSidebar()" aria-label="Open menu">
      <mat-icon>menu</mat-icon>
    </button>
  }

  @if (isFieldStep()) {
    <a routerLink="/requests" class="header-create-logo-link" aria-label="Kaizen">
      <img src="assets/logo.png" alt="Kaizen" class="header-create-logo" />
    </a>
  }

  @if (isWizardRoute) {
    <div class="header-create-stepper" role="navigation" aria-label="Create flow steps">
      @for (dot of visibleWizardDots(); track dot.step; let i = $index) {
        @if (i > 0) {
          <div class="header-create-stepper__line"
               [class.header-create-stepper__line--done]="isWizardStepComplete(dot.step - 1) || isWizardStepActive(dot.step)"></div>
        }
        <div class="header-create-stepper__node"
             [class.is-active]="isWizardStepActive(dot.step)"
             [class.is-complete]="isWizardStepComplete(dot.step)">
          <div class="header-create-stepper__circle">
            @if (isWizardStepComplete(dot.step)) {
              <mat-icon>check</mat-icon>
            } @else if (dot.step === 3) {
              <img class="header-create-stepper__send-icon" src="assets/sendiocn.png" alt="" />
            } @else {
              <mat-icon>{{ dot.icon }}</mat-icon>
            }
          </div>
          <span class="header-create-stepper__label">{{ dot.labelKey | translate }}</span>
        </div>
      }
    </div>
  }

  <span class="header-create-spacer"></span>

  <!-- <img src="assets/kapybara_icon.png" alt="Kapybara" class="header-create-kapybara" (click)="onToggleKapybara()" [title]="'kapybaraAssistant' | translate" /> -->

  <button mat-button [matMenuTriggerFor]="langMenu" class="header-create-lang-btn">
    <mat-icon>language</mat-icon>
    <span>{{ currentLangLabel }}</span>
  </button>
  <mat-menu #langMenu="matMenu">
    @for(lang of languages; track lang.code) {
      <button mat-menu-item (click)="switchLanguage(lang.code)">
        {{ lang.label }}
      </button>
    }
  </mat-menu>

  <div class="header-filed-div">
  <button mat-icon-button [matMenuTriggerFor]="profileMenu" class="header-create-profile-btn">
    <mat-icon>account_circle</mat-icon>
  </button>
  </div>
  <mat-menu #profileMenu="matMenu">
    @if(userDetails) {
      <button mat-menu-item disabled>
        <mat-icon>person</mat-icon>
        <span>{{ userDetails.FirstName }} {{ userDetails.LastName }}</span>
      </button>
    }
    <button mat-menu-item (click)="logout()">
      <mat-icon color="primary">logout</mat-icon>
      <span>{{ 'logOut' | translate }}</span>
    </button>
  </mat-menu>
</mat-toolbar>
